import { render } from "./Article.vue?vue&type=template&id=bb7ab836&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=bb7ab836&lang=css&scoped=true"
import "./Article.vue?vue&type=style&index=1&id=bb7ab836&lang=less"
import "./Article.vue?vue&type=style&index=2&id=bb7ab836&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7ab836"]])

export default __exports__